import { createFileRoute } from '@tanstack/react-router'
import { DocumentsContainer } from 'pages/documents/DocumentsContainer'

import { documentsSearchSchema } from './-searchParams'

const RouteComponent = () => {
  return <DocumentsContainer />
}

export const Route = createFileRoute('/documents/')({
  component: RouteComponent,
  validateSearch: documentsSearchSchema,
  staticData: {
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
